import {Link, Stack} from "@mui/material";
import {SOCIAL_MEDIAS} from "../constants";
import SwitchLanguageButton from "./SwitchLanguageButton";
import BviOnButton from "./BviOnButton";
const SocialMediaButtons = () => {

  return (
    <Stack direction={'row'} spacing={4}>
      <Stack direction={'row'} spacing={2.5} mr={4}>
        {SOCIAL_MEDIAS.map((sm, index) => {
          const Icon = sm.icon;
          return (
            <Link
              key={`social-media-button-${index}`}
              component={Link} href={sm.href} target={'_blank'}>
              <Icon sx={{color: 'primary.main', width: 26, height: 26}}/>
            </Link>
          )
        })}
      </Stack>
      <Stack direction={'row'} alignItems={'center'} spacing={3}>
        <BviOnButton />
        <SwitchLanguageButton />
      </Stack>
    </Stack>
  )
}

export default SocialMediaButtons
